// extracted by mini-css-extract-plugin
module.exports = {"container":"container___34pz7","image":"image___S_sBo","textContainer":"textContainer___iHto3","title":"title___ayrI_","description":"description___3w7zj"};